import { useTranslation } from 'react-i18next';
import { Card, useRouteDocumentTitle } from '@client/toolkit';
import { ReportingPaths } from '../reporting.router';
import { ConsumptionTable } from './components/consumption-table';
import { ConsumptionGraphSection } from './components/consumption-graph';
import { ReportPageContent } from '../../../components/layout/report-page-content';
import { DashboardFiltersProvider, useDashboardFilters } from '../../dashboard/context/dashboard-filters.context';
import { DashboardFilters } from '../../dashboard/components';
import {
  EosSourcesFilter,
  EosSourcesFilterContextProvider,
  useEosSourcesFilterContext,
} from '../../../components/eos/filters/eos-sources-filter';
import { eosDateRangeFilterVisiblePresets } from '../../../components/eos/config';
import { useGetEosTotalConsumptionQuery } from '@client/api';
import { StatCard } from '../../../components/eos';

function EosEnergyTotalConsumptionStatCard() {
  const { t } = useTranslation('eos');
  const { sources } = useEosSourcesFilterContext();
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data } = useGetEosTotalConsumptionQuery(
    {
      sources,
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );
  const { total = 0 } = data ?? {};
  return <StatCard title={t('totalConsumption')} value={`${total} kWh`} />;
}

function EosEnergyStatsCards() {
  return (
    <div className="flex gap-5">
      <EosEnergyTotalConsumptionStatCard />
    </div>
  );
}

export const ReportingConsumptionEnergyRoute = () => {
  const { t } = useTranslation('reporting');
  useRouteDocumentTitle(t('reporting.documentTitle'), ReportingPaths.ConsumptionEnergy);
  return (
    <DashboardFiltersProvider dateParamsPrefix="eos">
      <EosSourcesFilterContextProvider defaultSources={['enelyze']} selectionMode="single">
        <ReportPageContent
          breadcrumb={t('energyConsumptionTitle')}
          menu={<DashboardFilters showOnlySpacesWithEosEnabled visiblePresets={eosDateRangeFilterVisiblePresets} />}
        >
          <EosSourcesFilter />
          <EosEnergyStatsCards />
          <ConsumptionGraphSection />
          <Card>
            <ConsumptionTable />
          </Card>
        </ReportPageContent>
      </EosSourcesFilterContextProvider>
    </DashboardFiltersProvider>
  );
};
